/* eslint-disable react/require-default-props */
import { HeadingSmall, ParagraphMedium, ParagraphSmall } from 'baseui/typography';
import React, { } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useStyletron } from 'theme';
import {
  BookingReviewFormFields,
  TBookingForm,
} from './types';

export default function CitizensCharter(props: TBookingForm<FieldValues>) {
  const { onSubmit: onSubmitHandler, id: formId } = props;
  const [css, theme] = useStyletron();
  const { handleSubmit } = useForm<BookingReviewFormFields>();

  const onSubmit = handleSubmit(() => {
    onSubmitHandler({});
  });

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
      })}
    >
      <div>
        <HeadingSmall as="h1" $style={{ marginBottom: theme.sizing.scale400 }}>
          Citizen&apos;s Charter
        </HeadingSmall>
      </div>
      <form
        id={formId}
        onSubmit={onSubmit}
        className={css({ marginTop: theme.sizing.scale600 })}
      >
        <ParagraphMedium as="strong" $style={{
          marginBottom: theme.sizing.scale400,
          fontWeight: 700,
        }}>
          Welcome to the Citizen&apos;s Charter of the VPP Appointments Unit!
        </ParagraphMedium>
        <br />
        <br />
        <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
          We are dedicated to providing prompt, professional, and efficient assistance in managing
          appointments with the Vice President. This Charter presents the services we offer, our
          service commitments, and the standards you can expect. Our unit is committed to
          assisting individuals, organizations, and institutions in facilitating <strong>appointments with the
            Vice President</strong>, as well as <strong>requests for written and video messages</strong> for special events,
          milestones, and official functions. We aim to deliver prompt, courteous, and efficient
          service in every interaction.
        </ParagraphSmall>
        <br />
        <br />
        <ParagraphMedium as="strong" $style={{
          marginBottom: theme.sizing.scale400,
          fontWeight: 700,
        }}>
          Mandate
        </ParagraphMedium>
        <br />
        <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
          The VPP Appointments Unit is mandated to manage and process requests for:
        </ParagraphSmall>
        <ul style={{
          listStyle: 'disc',
          margin: '0 14px',
          padding: '2px 14px',
        }}>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              <strong>Appointments with the Vice President</strong>
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              <strong>Official written and video messages</strong> from the Vice President
            </ParagraphSmall>
          </li>
        </ul>
        <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
          We are committed to ensure that all requests are handled with professionalism,
          timeliness, and fairness, in line with the principles of public service and good governance.
        </ParagraphSmall>
        <br />
        <br />
        <hr />
        <br />

        <ParagraphMedium as="strong" $style={{
          marginBottom: theme.sizing.scale400,
          fontWeight: 700,
        }}>
          Core Services
        </ParagraphMedium>
        <br />
        <ul style={{
          listStyle: 'disc',
          margin: '0 14px',
          padding: '2px 14px',
        }}>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Receiving and evaluating appointment requests
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Coordinating schedules for approved engagements
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Processing requests for <strong>written and video messages</strong> from the Vice President
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Providing timely updates to requesting parties
            </ParagraphSmall>
          </li>
        </ul>
        <br />
        <hr />
        <br />

        <ParagraphMedium as="strong" $style={{
          marginBottom: theme.sizing.scale400,
          fontWeight: 700,
        }}>
          Service Standards
        </ParagraphMedium>
        <br />
        <ul style={{
          listStyle: 'disc',
          margin: '0 14px',
          padding: '2px 14px',
        }}>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Acknowledge requests within <strong>one working day</strong>
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Deliver <strong>courteous and professional</strong> service at all times
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Ensure <strong>efficient and consistent</strong> communication
            </ParagraphSmall>
          </li>
        </ul>
        <br />
        <hr />
        <br />

        <ParagraphMedium as="strong" $style={{
          marginBottom: theme.sizing.scale400,
          fontWeight: 700,
        }}>
          Client Responsibilities
        </ParagraphMedium>
        <br />
        <ul style={{
          listStyle: 'disc',
          margin: '0 14px',
          padding: '2px 14px',
        }}>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Submit complete and accurate information
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Adhere to guidelines provided by the Unit
            </ParagraphSmall>
          </li>
          <li>
            <ParagraphSmall as="strong" $style={{ marginBottom: theme.sizing.scale400 }}>
              Conduct transactions with courtesy and respect
            </ParagraphSmall>
          </li>
        </ul>
        <br />
        <hr />
        <br />
      </form>
    </div>
  );
}
